import { createContext, useContext } from "react";
import type { MatomoContextValue } from "./types";

/**
 * Matomo Context
 * Provides Matomo tracking functionality to the React component tree
 */
export const MatomoContext = createContext<MatomoContextValue | null>(null);

/**
 * Hook to access Matomo context
 * @throws Error if used outside of MatomoProvider
 */
export function useMatomoContext(): MatomoContextValue {
	const context = useContext(MatomoContext);

	if (!context) {
		throw new Error("useMatomoContext must be used within a MatomoProvider");
	}

	return context;
}
